import JSEncrypt from 'jsencrypt';
import * as environment from '../config/environment';

const encryptWithPublicKey = (data:string) => {
    const jsEncrypt = new JSEncrypt({default_key_size:"2048"});
    jsEncrypt.setPublicKey(environment.PUBLIC_KEY);
    return jsEncrypt.encrypt(data);
}

export {encryptWithPublicKey}